import * as toast from '@/../shared/store/modules/toast'

export const state = toast.state
export const getters = toast.getters
export const mutations = toast.mutations
export const actions = toast.actions
